import AuctionHousesTile from "./AuctionHousesTile";

export default AuctionHousesTile;
